<template>
  <v-container class="pa-0 ma-0" fluid>
    <v-toolbar flat color="toolbar">
      <v-toolbar-title class="ml-2 title">
        Period Closing
      </v-toolbar-title>
    <v-divider vertical inset class="mx-4" />
    <v-row dense class="align-center d-flex">
      <v-col cols="2" class="py-0">
        <v-autocomplete
          v-model="searchParams.billing_year_id"
          :items="billingYears"
          item-text="constant"
          item-value="id"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Year"
          style="height: 40px;"
          :menu-props="{ maxHeight: 260, rounded: '' }"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2" class="py-0">
        <v-autocomplete
          v-model="searchParams.billing_period_id"
          :items="billingPeriods"
          item-text="constant"
          item-value="id"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Period"
          style="height: 40px;"
          :menu-props="{ maxHeight: 260, rounded: '' }"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2" class="py-0">
        <v-autocomplete
          v-model="searchParams.recap_component_id"
          :items="recapComponents"
          item-text="name"
          item-value="id"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Component"
          style="height: 40px;"
          :menu-props="{ maxHeight: 260, rounded: '' }"
          clearable>
        </v-autocomplete>
      </v-col>
      <v-col cols="2" class="py-0">
        <v-text-field
          v-model="searchParams.store_number"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Store #"
          style="height: 40px;"
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col style="display: grid; justify-content: flex-end; grid-auto-flow: column; grid-column-gap: 12px">
        <v-btn
          color="accent"
          :disabled="!(searchParams.billing_year_id && searchParams.billing_period_id && autoRecapAdditions.length)"
          @click="DownloadRecapAdditions">
          <v-icon>mdi-file-download-outline</v-icon>
        </v-btn>
        <v-btn
          :color="getStatusColor(process.status)"
          class="white--text"
          @click="component='PeriodCloseModal', modal=true, updateProcessOnClick(process, 'WAITING')"
          :loading="process_loading || process.status === 'RUNNING'">
          <v-icon left v-if="!(process_loading || process.status === 'RUNNING')">mdi-calendar-check</v-icon>
          {{ process ? getProcessButtonText(process) : 'Close Billing Period'}}
          <template v-slot:loader>
            <span :class="getLoader(process.status)">
              <v-icon dark>{{getLoaderIcon(process)}}</v-icon>
            </span>
          </template>
        </v-btn>
      </v-col>
    </v-row>
    </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        dense
        :items="autoRecapAdditions"
        :items-per-page.sync="pageSize"
        :headers="headers"
        :height="tableSize"
        :loading="loading"
        item-key="id"
        :style="{'position': 'relative', 'z-index': '1'}"
        fixed-header
        hide-default-footer>
        <template #[`item.amount`]="{ item }">
          <div>{{ '$' + formatCurrencyDisplay(item.amount) }}</div>
        </template>
      </v-data-table>
      <v-divider/>
      <v-toolbar flat color="#fafafa">
        <v-row align="center" justify="end">
          <v-col cols="2" style="max-width:150px;">
            <v-select class="mt-8" dense :items="pageSizes" label="Items Per Page" select v-model="pageSize"
              :menu-props="{ top: true, offsetY: true, maxHeight: 500 }">
            </v-select>
          </v-col>
          <v-btn icon large @click="previous()" :disabled="disablePrevious" class="mx-2">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <small>Page {{page}}</small>
          <v-btn icon large @click="next()" :disabled="disableNext" class="mx-2">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </v-toolbar>
      <Component
        v-if="modal"
        :is="component"
        :value.sync="modal"
        @close="closeModal"
        @closeProcessModal="closeProcessModal">
      </Component>
  </v-container>
</template>
<script>
// import Party from '@/axios/party'
import RecapAdditions from '@/axios/recap-additions'
import PeriodCloseModal from '@/components/PeriodCloseModal.vue'
import { format } from '@/mixins/format'
import { fullWidth } from '@/mixins/fullWidth'
import { displayAlert } from '@/mixins/displayAlert'
import { dateFormat } from '@/mixins/date-format'
import { userAccess } from '@/mixins/user-access'
export default {
  data () {
    return {
      autoRecapAdditions: [],
      processes: [],
      process_loading: true,
      process_timer: '',
      searchParams: {},
      component: '',
      modal: false,
      loading: false,
      page: 1,
      pageSize: 200,
      pageSizes: [50, 100, 200],
      headerProps: {
        class:'accent white--text', width: 'auto'
      }
    }
  },
  name: 'PeriodClose',
  mixins: [format, fullWidth, displayAlert, dateFormat, userAccess],
  components: { PeriodCloseModal },
  watch: {
    searchParams: {
      handler() {
        this.page = 1
        this.getAutoRecapAdditions()
      },
      deep: true
    },
    pageSize: {
      handler() {
        this.page = 1
        this.getAutoRecapAdditions()
      }
    }
  },
  async created () {
    this.nonTableHeight = 228
    this.loading = true
    try {
      this.getProcesses()
      this.process_timer = setInterval(this.getProcesses, 300000);
      await Promise.all([
        this.$store.dispatch('getStores'),
        this.$store.dispatch('getBillingYears'),
        this.$store.dispatch('getBillingPeriods'),
        this.$store.dispatch('getRecapComponents'),
        this.$store.dispatch('getRecapAdditionStatuses')
      ])
      await this.getAutoRecapAdditions()
    } catch (err) {
      this.handleError(err)
      this.loading = false
    } 
  },
  beforeDestroy() {
    clearInterval(this.process_timer);        
    this.process_timer = null;
  },
  computed: {
    process() {
      if (this.processes.length > 0) {
        return this.processes.find(p => p?.name === 'arg-period-close')
      }
      return { buttonText: 'Close Billing Period', status: 'WAITING' }
    },
    headers () {
      return [
        { class:'accent white--text', sortable: false },
        { text: 'Year', value: 'billing_year' },
        { text: 'Period', value: 'billing_period', align: 'center' },
        { text: 'Recap Addition', value: 'recap_component', align:'center' },
        { text: 'Store Name',value: 'store_name', align:'center' },
        { text: 'Amount', value: 'amount',  align:'center' },
        { text: 'Status', value: 'status',  align:'center' },
      ].map(header => ({ ...header, ...this.headerProps }))
    },
    billingPeriods () {
      return this.$store.getters.billingPeriods || []
    },
    billingYears () {
      return this.$store.getters.billingYears || []
    },
    recapComponents () {
      const components = this.$store.getters.recapComponents
      if (components?.length > 0) {
        return components.filter(comp => comp.component_type === 'AUTO')
      }
      return []
    },
    recapAddStatuses() {
      return this.$store.getters.recapAddStatuses || []
    },
    stores () {
      return this.$store.getters.stores || []
    },
    offset () {
      return (this.page - 1) * this.pageSize
    },
    disablePrevious () {
      return this.offset === 0
    },
    disableNext () {
      return this.autoRecapAdditions.length < this.pageSize
    }
  },
  methods: {
    async getAutoRecapAdditions () {
      this.loading = true
      const params = {
        limit: this.pageSize,
        offset: this.offset,
        ...Object.fromEntries(Object.entries(this.searchParams).filter(([_, v]) => _ && v ))
      }
      let autoRecapAdditions = []
      params.component_type = 'AUTO'
      // params.status = 'PENDING'
      try {
        const { data } = await RecapAdditions.getList(params)
        if (data?.length > 0) {
          autoRecapAdditions = data.map(ra => {
            ra.billing_year = this.billingYears.find(by => by.id === ra.billing_year_id)?.constant
            ra.billing_period = this.billingPeriods.find(bp => bp.id === ra.billing_period_id)?.constant
            ra.recap_component = this.recapComponents.find(rc => rc.id === ra.recap_component_id)?.name
            ra.status = this.recapAddStatuses.find(bp => bp.id === ra.recap_addition_status_id)?.constant
            const party = this.stores.find(store => store.id === ra.party_id)
            ra.party = party
            ra.store_name = party?.name
            return ra
          })
        }
        this.autoRecapAdditions = autoRecapAdditions
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async DownloadRecapAdditions () {
      this.loading = true
      const params = {
        limit: 500,
        ...Object.fromEntries(Object.entries(this.searchParams).filter(([_, v]) => _ && v ))
      }
      params.component_type = 'AUTO'
      try {
        const res = await RecapAdditions.downloadRecapAdditions(params)
        location.href = res.data;
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async getProcesses() {
      const params = {}
      this.process_loading = true
      try {
        const res = await this.$Processes.getProcessList(params)
        this.processes = res.data.filter(p => p.name === 'arg-period-close')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.process_loading = false
      }
    },
    updateProcessOnClick (process, status) {
      if (process.status.includes("COMPLETED") || process.status.includes("FAILED")) {
        this.updateProcessStatus(process, status)
      }
    },
    async updateProcessStatus (process, status) {
      this.process_loading = true
      try {
        const params = {"status": status}
        await this.$Processes.updateProcessStatus(process.process_id, params)
      } catch (err) {
        this.handleError(err)
      } finally {
        this.process_loading = false
      }
    },
    getProcessButtonText(process) {
      if (process.status === "WAITING" || process.status === "COMPLETED") {
        return 'Close Billing Period'
      } 
      return process.status
    },
    getStatusColor (status) {
      if (!status) return 'primary'
      switch (status.toLowerCase()) {
        case 'waiting':
          return 'primary'
        case 'running':
          return 'purple'
        case 'uploading':
          return 'orange'
        case 'completed':
          return 'green'
        case 'failed':
          return 'red'
        case 'cancelled':
          return 'grey lighten-1'
      }
    },
    getLoader (status) {
      if (status === "RUNNING" || (!status)) {
        return 'loader-running'
      }
      else if (status === "UPLOADING"){
        return 'loader-uploading'
      }
    },
    getLoaderIcon (process) {
      if (!process.status) {
        return 'mdi-loading'
      }
      else {
        if (process.status === "RUNNING") {
          return "mdi-cached"
        }
        else if (process.status === "UPLOADING") {
          return "mdi-email-fast"
        }
      }
    },
    closeModal (update = false) {
      this.modal = false
      this.selectedRecapAddition = null
      if (update) {
        this.getAutoRecapAdditions()
      }
    },
    closeProcessModal () {
      this.modal = false
      this.getProcesses()
    },
    previous() {
      if (this.page > 1) {
        this.page -= 1
        this.getAutoRecapAdditions()
      }
    },
    next() {
      if (!this.disableNext) {
        this.page += 1
        this.getAutoRecapAdditions()
      }
    },
  }
}
</script>
<style>
  .loader-running {
    animation: rotator 1s infinite;
    display: flex;
  }
  @-moz-keyframes rotator {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes rotator {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes rotator {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes rotator {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .loader-uploading {
    animation: slide 2.5s infinite;
    display: flex;
    transform: translate(-30px, 30px);
  }
    @-moz-keyframes slide {
    from {
      transform: translate(-30px);
    }
    to {
      transform: translate(30px);
    }
  }
  @-webkit-keyframes slide {
    from {
      transform: translate(-30px);
    }
    to {
      transform: translate(30px);
    }
  }
  @-o-keyframes slide {
    from {
      transform: translate(-30px);
    }
    to {
      transform: translate(30px);
    }
  }
  @keyframes slide {
    from {
      transform: translate(-30px);
    }
    to {
      transform: translate(30px);
    }
  }
</style>